import styled from "styled-components"
import { ExpandButton } from "./CustomerOrderTable.styled"
import { ReactComponent as CopyIcon } from "images/icons/copy.svg"

export const Container = styled.div`
  margin-top: 3rem;
`

export const Email = styled.h3`
  color: ${({ theme }) => theme.colors.turquoiseDark};
`

export const TableHeader = styled.div`
  margin-top: 1rem;
  display: grid;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  border-left: none;
  grid-template-columns: 4fr 1fr 1fr;
    ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
        grid-template-columns: 4fr 1fr 2fr 1fr;
    }

  ${(p) => p.theme.mQ.MEDIA_MIN_X_LARGE} {
    grid-template-columns: 4fr 1fr 1.5fr 1fr 1fr 1fr;
  }
`

export const Section = styled.div`
  font-weight: 700;
  padding: 1rem;
  border-left: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7rem;
`

export const CheckoutHeader = styled(Section)`
  display: flex;
  justify-self: flex-start;
`

export const TableRow = styled(TableHeader)`
  margin-top: 0;

  div {
    font-weight: 400;
  }
`

export const CheckoutCell = styled(Section)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 2rem;
`

export const DateTime = styled(Section)`
  display: flex;
  justify-content: flex-start;

  div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    span {
      line-height: 1.9rem;
      display: flex;
      justify-content: flex-start;
    }
  }
`

export const TotalAmount = styled.div`
  font-weight: 600;
  font-size: 1.3rem;
`

export const ItemCount = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.1rem;
`

export const OrderLinesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.greyLightest};
  border-left: 4px solid ${({ theme }) => theme.colors.turquoiseDark};
`

export const OrderLinesHeader = styled.div`
  padding: 1rem 2rem;
  font-weight: 600;
  font-size: 1.1rem;
  border-bottom: 2px solid ${({ theme }) => theme.colors.borderLight};
  margin-left: 3rem;
  color: ${({ theme }) => theme.colors.black};
`

export const OrderLinesTableHeader = styled.div`
  display: grid;
  grid-template-columns: 20rem 6rem 8rem 12rem 1fr;
  align-items: center;
  padding: 0.6rem 0;
  margin-left: 4rem;
  background-color: ${({ theme }) => theme.colors.greyLighter};
  font-weight: 600;
  font-size: 1.0rem;
  color: ${({ theme }) => theme.colors.greyDarker};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`

export const OrderLineRow = styled.div`
  display: grid;
  grid-template-columns: 20rem 6rem 8rem 12rem 1fr;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.borderLight};
  margin-left: 4rem;
  background-color: ${({ theme }) => theme.colors.blueLight};
`

export const ProductInfo = styled.div`
  padding-left: 1rem;
`

export const ProductName = styled.div`
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
`

export const QuantityCell = styled.div`
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
`

export const UnitPriceCell = styled.div`
  text-align: right;
  font-size: 1.0rem;
`

export const DiscountedBasePrice = styled.div`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.greyDark};
  font-size: 0.9rem;
`

export const SalePrice = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.turquoiseDark};
`

export const RegularPrice = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`

export const TotalCell = styled.div`
  text-align: right;
  font-weight: 700;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.black};
`

export const CheckoutRowContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ExpandButtonStyled = styled(ExpandButton)`
  width: 3rem;
    padding-right: 1.6rem;
  height: 3rem;
  margin-right: 2rem;
  border: none;
  background: transparent;
`

export const OrderReferenceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ConfirmedOrderReference = styled.span`
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  position: relative;

  &:after {
    content: "";
    width: 0;
  }

  &:hover {
    &:after {
      transition: 0.4s width ease-out;
      content: "";
      width: 100%;
      background: ${({ theme }) => theme.colors.black};
      height: 0.1rem;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`

export const UnconfirmedOrderReference = styled.span`
  font-weight: 600;
  font-size: 1.2rem;
  cursor: default;
`

export const CheckoutIdContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const CopyIconStyled = styled(CopyIcon)`
  width: 1.2rem;
  height: 1.2rem;
  cursor: pointer;
  opacity: 0.7;
  margin-right:1rem;

  &:hover {
    opacity: 1;
  }
`

export const AmountUpIndicator = styled.div`
  background-color: ${({ theme }) => theme.colors.turquoiseLighter};
  border: 0.1rem solid ${({ theme }) => theme.colors.turquoiseDark};
  border-radius: 50%;
  height: 4rem;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.turquoiseDark};
  cursor: help;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.turquoiseLight};
    transform: scale(1.05);
  }
`

export const AmountDownIndicator = styled.div`
  background-color: ${({ theme }) => theme.colors.yellowLighter};
  border: 0.1rem solid ${({ theme }) => theme.colors.yellowDark};
  border-radius: 50%;
  height: 4rem;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.yellowDark};
  cursor: help;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.yellowLight};
    transform: scale(1.05);
  }
`
